"use client";
import { Button } from "antd";
import { MailOutlined } from "@ant-design/icons";
import React from "react";
import { useTranslations } from "next-intl";
import { useModalInquiryContext } from "@/context/ModalInquiryContext";
import Image from "next/image";
import { CardsThree, Bookmark, CalendarCheck, NumberCircleOne, ArrowFatLinesUp } from "@phosphor-icons/react";

const ContactBox = () => {
	const t = useTranslations();
	const { openModalInquiry } = useModalInquiryContext();
	return (
		<>
			<div
				className="flex gap-4 rounded-t-md px-[19px] py-3"
				style={{
					backgroundImage: "linear-gradient(90deg, #eaeff5 0%,  #fbfcfd 100%)",
				}}
			>
				<Image
					src="/image/logo1.png"
					width={100}
					height={50}
					alt="JS Precision logo"
					className="object-cover max-md:h-12 max-md:w-12"
				></Image>
				<span className="text-md my-auto text-center font-bold">{t("contactBox.companyName")}</span>
			</div>

			<div className="h-fit p-2">
				<ul className="mb-3">
					<li className="my-1 flex items-center justify-start rounded bg-gray-50 p-1">
						<div className="w-8">
							<CalendarCheck size={23} />
						</div>
						<p className="flex-1">{t("contactBox.t1")}</p>
					</li>
					<li className="my-1 flex items-center justify-start rounded bg-gray-50 p-1">
						<div className="w-8">
							<Bookmark size={23} />
						</div>
						<p className="flex-1">{t("contactBox.t2")}</p>
					</li>
					<li className="my-1 flex items-center justify-start rounded bg-gray-50 p-1">
						<div className="w-8">
							<CardsThree size={23} />
						</div>
						<p className="flex-1">{t("contactBox.t3")}</p>
					</li>
					<li className="my-1 flex items-center justify-start rounded bg-gray-50 p-1">
						<div className="w-8">
							<ArrowFatLinesUp size={23} />
						</div>
						<p className="flex-1">{t("contactBox.t4")}</p>
					</li>
					<li className="my-1 flex items-center justify-start rounded bg-gray-50 p-1">
						<div className="w-8">
							<NumberCircleOne size={23} />
						</div>
						<p className="flex-1">{t("contactBox.t5")}</p>
					</li>
				</ul>
				<Button onClick={openModalInquiry} shape="round" type="primary" size="large" className="w-full">
					<MailOutlined />
					{t("base.getInstantQuote")}
				</Button>
				{/*<Button onClick={openModalInquiry} shape="round" size="large" className="w-full">*/}
				{/*	<ChatCircleText size={16} weight="bold" />*/}
				{/*	{t("base.chat")}*/}
				{/*</Button>*/}
			</div>
		</>
	);
};
export default ContactBox;
